import { topicItems } from '@/mocks/homeData';

const colorMap: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-700 border-accent-200',
  primary: 'bg-primary-100 text-primary-700 border-primary-200',
  secondary: 'bg-secondary-100 text-secondary-700 border-secondary-200',
};

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-18 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center">
          热门话题
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          大家都在讨论的影视热点 · 实时更新
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <a
              key={item.id}
              href="#topics"
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium whitespace-nowrap cursor-pointer transition-all hover:scale-105 ${
                colorMap[item.color] || colorMap.primary
              }`}
            >
              <span>{item.tag}</span>
              <span className="text-[11px] opacity-70">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}